import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, AlertCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { signOut } from '../lib/auth';

const AccountDeactivatedScreen: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="bg-white p-8 rounded-xl shadow-sm border border-[#EAECF0]">
          <div className="w-12 h-12 bg-[#FEF3F2] rounded-full flex items-center justify-center mx-auto mb-6">
            <AlertCircle className="w-6 h-6 text-[#B42318]" />
          </div>

          <h2 className="text-2xl font-semibold text-[#101828] mb-3">
            Account Deactivated
          </h2>
          
          <p className="text-[#667085] mb-4">
            Your account has been deactivated. Please contact support for assistance
            in reactivating your account.
          </p>

          <p className="text-[#667085] mb-8">
            <a 
              href="mailto:support@example.com"
              className="text-[#7F56D9] hover:text-[#6941C6]"
            >
              support@example.com
            </a>
          </p>

          <Button
            variant="secondary"
            onClick={handleLogout}
            leftIcon={<LogOut className="w-4 h-4" />}
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeactivatedScreen;